import { z } from 'zod';

const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;

export const userSchema = z
  .object({
    rfc: z
      .string()
      .min(1, 'El RFC es obligatorio')
      .max(13, 'Máximo 13 caracteres')
      .optional()
      .or(z.literal('')),
    curp: z.string().max(18, 'Máximo 18 caracteres').optional().or(z.literal('')),
    username: z.string().min(1, 'El nombre de usuario es obligatorio'),
    name: z.string().min(1, 'El nombre es obligatorio'),
    firstLastName: z.string().min(1, 'El primer apellido es obligatorio'),
    secondLastName: z.string().min(1, 'El segundo apellido es obligatorio'),
    email: z.string().min(1, 'El correo es obligatorio').email('Formato incorrecto'),
    role: z.string().min(1, 'El rol es obligatorio'),
    password: z
      .string()
      .min(8, 'Mínimo 8 caracteres')
      .regex(PASSWORD_REGEX, 'Debe tener mayúscula, minúscula, número y carácter especial'),
    passwordConfirmation: z.string().min(1, 'Confirma la contraseña'),
    status: z.boolean(),
  })
  .refine((data) => data.password === data.passwordConfirmation, {
    message: 'Las contraseñas no coinciden',
    path: ['passwordConfirmation'],
  });

export const updateUserSchema = z
  .object({
    rfc: z
      .string()
      .min(1, 'El RFC es obligatorio')
      .max(13, 'Máximo 13 caracteres')
      .optional()
      .or(z.literal('')),
    curp: z.string().min(1,'La curp es obligatoria').max(18, 'Máximo 18 caracteres'),
    username: z.string().min(1, 'El nombre de usuario es obligatorio'),
    name: z.string().min(1, 'El nombre es obligatorio'),
    firstLastName: z.string().min(1, 'El primer apellido es obligatorio'),
    secondLastName: z.string().min(1, 'El segundo apellido es obligatorio'),
    email: z.string().min(1, 'El correo es obligatorio').email('Formato incorrecto'),
    password: z
      .string()
      .optional()
      .or(z.literal(''))
      .refine((val) => !val || (val.length >= 8 && PASSWORD_REGEX.test(val)), {
        message: 'Mínimo 8 caracteres con mayúscula, minúscula, número y carácter especial',
      }),
    passwordConfirmation: z.string().optional().or(z.literal('')),
    role: z.string().min(1, 'El rol es obligatorio'),
    status: z.boolean(),
  })
  .refine((data) => !data.password || data.password === data.passwordConfirmation, {
    message: 'Las contraseñas no coinciden',
    path: ['passwordConfirmation'],
  });
